import EFPicture from 'elem/compCommon/EFPicture';
import { useGlobal } from '@/utils/useGlobal';

export default function I() {
    const { useEffect, useState, useLang, gtm, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('solar_panel_160w_single');
    return (
        <div className="sp-160-single-I">
            <p className="title">{t('I_title')}</p>
            <div className="inner-box">
                <div className="left box">
                    <EFPicture src="/responsive/picture/solar-panel-160w-single/9_1.png" alt={t('I_1_text')} />
                    <p className="box-text">{t('I_1_text')}</p>
                </div>
                <div className="right">
                    <div className="r-t">
                        <div className="r-t-l box">
                            <EFPicture src="/responsive/picture/solar-panel-160w-single/9_2.png" alt={t('I_2_text')} />
                            <p className="box-text">{t('I_2_text')}</p>
                        </div>
                        <div className="r-t-r box">
                            <EFPicture src="/responsive/picture/solar-panel-160w-single/9_3.png" alt={t('I_3_text')} />
                            <p className="box-text">{t('I_3_text')}</p>
                        </div>
                    </div>
                    <div className="r-b box">
                        <EFPicture src="/responsive/picture/solar-panel-160w-single/9_4.png" alt={t('I_4_text')} />
                        <p className="box-text">{t('I_4_text')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
